import React, { useRef } from "react"
import CrossIcon from "../../svg/icons/CrossIcon"
import Nouislider from "nouislider-react"
import "nouislider/distribute/nouislider.css"
import LivescoringFilterGenderButton from "./LivescoringFilterGenderButton"
import LivescoringFilterTeeButton from "./LivescoringFilterTeeButton"

const checkTeesAreLadyAndGentlemen = (tees) => {
    if (!Array.isArray(tees) || tees.length !== 2) {
        return false
    }

    const categoryNames = tees.map(tee => tee.categoryName)

    return categoryNames.includes("Caballeros") && categoryNames.includes("Señoras")
}

const LivescoringFilter = ({
    isOpen,
    toggleIsOpen,
    filters,
    updateFilters,
    maxPlayerHandicap,
    minPlayerHandicap,
    tees,
    cleanFilters,
    onPositionCalculationKeyChange = () => {},
    onCalculationChange = () => {},
    showTotal,
    showToggle,
    positionCalculationKey,
    calculationSelected,
    roundColumns = []
}) => {
    const filterContainerRef = useRef()

    if (!isOpen) {
        return <></>
    }

    const minHandicapSelected = filters.handicap.min ?? minPlayerHandicap
    const maxHandicapSelected = filters.handicap.max ?? maxPlayerHandicap
    const handicapRangeIsValid = Number.isFinite(minPlayerHandicap)
        && Number.isFinite(maxPlayerHandicap)
        && minPlayerHandicap < maxPlayerHandicap

    const teesAreLadyAndGentlemen = checkTeesAreLadyAndGentlemen(tees)

    const closeFromOverlay = (event) => {
        if (!filterContainerRef.current.contains(event.target)) {
            toggleIsOpen()
        }
    }

    return (
        <div className="livescoring-filter" onClick={closeFromOverlay}>
            <div ref={filterContainerRef} className="livescoring-filter-container">
                <div className="livescoring-filter-header">
                    <button onClick={cleanFilters} className="livescoring-filter-clean-button">Limpiar</button>
                    <div className="livescoring-filter-header-rightSide">
                        <div onClick={toggleIsOpen} className="livescoring-filter-close-btn">
                            <CrossIcon/>
                        </div>
                    </div>
                </div>

                <div className="livescoring-filter-content filter-ordering">
                    {
                        showToggle &&
                        <div className="changeToggle">
                            <label className="toggle-label no-highlights">
                                <input
                                    className="toggle-input livescoring-toggle"
                                    type="checkbox"
                                    checked={"H" === calculationSelected}
                                    onChange={onCalculationChange}
                                />
                                <div className="toggle-switch">
                                    <span className="toggle-thumb"></span>
                                </div>
                            </label>
                        </div>
                    }
                    {
                        showTotal &&
                        <div className="changeToggle toggle-show-day">
                            <label className="toggle-label no-highlights">
                                <input
                                    className="toggle-input livescoring-toggle"
                                    type="checkbox"
                                    checked={"H" === positionCalculationKey || "S" === positionCalculationKey}
                                    onChange={onPositionCalculationKeyChange}
                                />
                                <div className="toggle-switch">
                                    <span className="toggle-thumb"></span>
                                </div>
                            </label>
                        </div>
                    }
                </div>

                <div className="livescoring-filter-content">
                    {
                        roundColumns.length > 1 &&
                        <div className="livescoring-filter-rounds livescoring-filter-section">
                            <label className="livescoring-filter-label">Jornadas</label>
                            <div className="livescoring-filter-rounds-content">
                                {
                                    roundColumns.map(roundColumn => (
                                        <label key={roundColumn.roundId} className="livescoring-filter-round-item">
                                            <input
                                                type="checkbox"
                                                checked={filters.rounds.includes(roundColumn.roundId)}
                                                onChange={() => updateFilters("rounds", roundColumn.roundId)}
                                            />
                                            <span>{ roundColumn.roundName || `J${roundColumn.roundNumber}` }</span>
                                        </label>
                                    ))
                                }
                            </div>
                        </div>
                    }

                    <div className="livescoring-filter-gender livescoring-filter-section">
                        <LivescoringFilterGenderButton
                            value="male"
                            filters={filters}
                            updateFilters={updateFilters}
                        />
                        <LivescoringFilterGenderButton
                            value="female"
                            filters={filters}
                            updateFilters={updateFilters}
                        />
                    </div>

                    <div className="livescoring-filter-handicap livescoring-filter-section">
                        <div className="livescoring-filter-handicap-label-container">
                            <label className="livescoring-filter-label">Hándicap</label>
                            <div className="livescoring-filter-handicap-label-inputs-container">
                                <input
                                    type="number"
                                    className="livescoring-filter-handicap-label-input"
                                    value={minHandicapSelected}
                                    min={minPlayerHandicap}
                                    max={maxPlayerHandicap}
                                    step={1}
                                    disabled={!handicapRangeIsValid}
                                    onChange={(event) => {
                                        const inputValue = Number(event.target.value)
                                        if (inputValue >= minPlayerHandicap && inputValue <= maxHandicapSelected) {
                                            updateFilters("handicap", {
                                                min: inputValue,
                                                max: maxHandicapSelected
                                            })
                                        }
                                    }}
                                />
                                <span>-</span>
                                <input
                                    type="number"
                                    className="livescoring-filter-handicap-label-input"
                                    value={maxHandicapSelected}
                                    min={minPlayerHandicap}
                                    max={maxPlayerHandicap}
                                    step={0.1}
                                    disabled={!handicapRangeIsValid}
                                    onChange={(event) => {
                                        const inputValue = Number(event.target.value)
                                        if (inputValue <= maxPlayerHandicap && inputValue >= minHandicapSelected) {
                                            updateFilters("handicap", {
                                                min: minHandicapSelected,
                                                max: inputValue
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {
                            handicapRangeIsValid &&
                                <div className="livescoring-filter-handicap-input-container">
                                    <Nouislider
                                        range={{min: minPlayerHandicap, max: maxPlayerHandicap}}
                                        start={[minHandicapSelected, maxHandicapSelected]}
                                        connect={[false, true, false]}
                                        step={0.1}
                                        onChange={({0: min, 1: max}) => {
                                            updateFilters("handicap", {min: Number(min), max: Number(max)})
                                        }}
                                    />
                                </div>
                        }
                    </div>

                    {
                        (tees.length > 1 && !teesAreLadyAndGentlemen) &&
                        <>
                            <div className="livescoring-filter-tee livescoring-filter-section">
                                <label className="livescoring-filter-label">Categorías</label>

                                <div className="livescoring-filter-tee-content">
                                    {
                                        tees.map(({teeId, teeName, teeAlias, categoryId, categoryName}) => (
                                            <LivescoringFilterTeeButton
                                                key={categoryId}
                                                teeId={teeId}
                                                teeName={teeName}
                                                teeAlias={teeAlias}
                                                categoryId={categoryId}
                                                categoryName={categoryName}
                                                filterTees={filters.tees}
                                                updateFilters={updateFilters}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default LivescoringFilter
